module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-426.0a07ff2.woff2";